import React from 'react'
import ClosureSurvey from 'sprockets_react/closure_survey/registry'

ClosureSurvey.NavigationButtons = function (props) {
  const { onStepProgression, onStepRetreat, navButtonLayout, onSecondaryNavButtonClick, onModalExit } = props
  const { leftButton, rightButton } = props.buttons || {}
  const label = props.label || ''
  const layoutChooser = {
    'default'        :  twoButton,
    'nextButton'     :  nextButton,
    'backButton'     :  backButton,
    'exitButton'     :  exitButton,
    'submitButton'   :  submitButton,
    'none': () => null
  }

  function submitButton() {
    return (
      <div className="row">
        <div className="col-xs-12">
          <a href="#" id="modal-nav-one-button" className="btn btn-block btn-main radius-6" style={{'whiteSpace': 'normal'}} onClick={onStepProgression}>
            {label}
          </a>
        </div>
      </div>
    )
  }

  function exitButton() {
    return (
      <div className="row">
        <div className="col-xs-12">
          <a href="#" className="btn btn-block btn-main modal-exit-button radius-6" onClick={onModalExit}>
            Close
          </a>
        </div>
      </div>
    )
  }

  function nextButton() {
    return (
      <div className="row">
        <div className='col-sm-6 col-xs-6 pb12 pull-right'>
          <a href="#" className="btn btn-block btn-secondary p12 radius-6" onClick={onStepProgression}>
            {rightButton ? rightButton.text : 'Next'}
            <i className='ficon-arrow-right-shaft pl10 fs14' />
          </a>
        </div>
      </div>
    )
  }

  function backButton() {
    return (
      <div className="row">
        <div className='col-sm-6 col-xs-6 pl16'>
          <a href="#" className="btn btn-block btn-clear radius-6" onClick={onStepRetreat}>
            <i className='ficon-arrow-left-shaft pr10 fs14' />
            {leftButton ? leftButton.text : 'Back'}
          </a>
        </div>
      </div>
    )
  }

  function twoButton() {
    return (
      <div className="row two-button-footer">
        <div className='col-sm-6 col-xs-6 pl4 pull-right'>
          <a href="#" id="modal-nav-right-button" className={rightButton ? rightButton.className : 'btn btn-block btn-secondary radius-6'} onClick={onStepProgression}>
            {rightButton ? rightButton.text : 'Next'}
            <i className={rightButton ? rightButton.iconClass : 'ficon-arrow-right-shaft pl10 fs14'} />
          </a>
        </div>
        <div className='col-sm-6 col-xs-6 pull-left pr4'>
          <a href="#" id="modal-nav-left-button" className="btn btn-block btn-clear radius-6" onClick={onStepRetreat}>
            <i className={leftButton ? leftButton.iconClass : 'ficon-arrow-left-shaft pr10 fs14'} />
            {leftButton ? leftButton.text : 'Back'}
          </a>
        </div>
      </div>
    )
  }
  return layoutChooser[navButtonLayout]()
}
